import { Box, TextField, Typography } from "@mui/material";
import { getPatientList } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import React, { useEffect, useState } from "react";
import { BoxContainer, BoxHeader, FilterButton } from "./styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridCustomPagination } from "components/helpers";
import { columns } from "./helper";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { DATE_FORMAT } from "utils/helper";

const Patients = () => {
  const userData = useUserData();
  const token = userData?.access_token;
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [patientId, setPatientID] = useState("");
  const [dob, setDob] = useState(null);
  const [showClear, setShowClear] = useState(false);

  useEffect(() => {
    getPatients();
  }, []);

  const getPatients = async (extraPayload = {}) => {
    setLoading(true);
    try {
      const payload = {
        practice_id: `${userData?.selected_practice}`,
        ...extraPayload,
      };
      const response = await getPatientList(payload, token);
      if (response) {
        setPatients(response);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const onFilter = () => {
    const extraPayload = {};
    if (name) {
      extraPayload.name = name;
    }
    if (patientId) {
      extraPayload.patient_id = patientId;
    }
    if (dob) {
      extraPayload.dob = dayjs(dob).format("MM/DD/YYYY");
    }
    getPatients(extraPayload);
    setShowClear(true);
  };

  const onClear = () => {
    setName("");
    setPatientID("");
    setDob(null);
    setShowClear(false);
    getPatients();
  };

  return (
    <BoxContainer>
      <BoxHeader>
        <Typography fontSize={18} fontWeight={500}>
          Patients
        </Typography>
        <Typography variant="body2">
          You are seeing the latest 100 patients.
        </Typography>
      </BoxHeader>

      <Box
        display="flex"
        alignItems="center"
        gap={2}
        mb={2}
        justifyContent="flex-end"
      >
        <TextField
          value={name}
          onChange={(e) => setName(e.target.value)}
          label="Patien Name"
          variant="standard"
          size="small"
          disabled={loading}
        />
        <TextField
          value={patientId}
          onChange={(e) => setPatientID(e.target.value)}
          label="Patien ID"
          variant="standard"
          size="small"
          disabled={loading}
        />
        <DesktopDatePicker
          disableToolbar
          slotProps={{
            textField: {
              variant: "standard",
              label: "DOB",
              size: "small",
            },
          }}
          format={DATE_FORMAT}
          value={dayjs(dob)}
          onChange={(e) => setDob(e)}
          className="notes-content"
          autoOk
          disabled={loading}
        />
        <FilterButton
          onClick={onFilter}
          variant="outlined"
          disabled={name === "" && patientId === "" && !dob}
        >
          Filter
        </FilterButton>
        {showClear && (
          <FilterButton onClick={onClear} variant="outlined">
            Clear
          </FilterButton>
        )}
      </Box>

      <DataGrid
        rows={loading ? [] : patients}
        columns={columns}
        autoHeight
        disableRowSelectionOnClick
        pagination
        pageSize={20}
        density="compact"
        getRowId={(row) => row.patient_id}
        slots={{
          pagination: DataGridCustomPagination,
          toolbar: GridToolbar,
        }}
        loading={loading}
      />
    </BoxContainer>
  );
};

export default Patients;
